import { Component, forwardRef, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAbstractView } from '@core/interfaces';
import { QuantityStepperPresenter } from './quantity-stepper.presenter';
import { IQuantityStepperComponent, IQuantityStepperPresenter } from './interfaces';
import { IconComponent } from '../icon/icon.component';
import { InputComponent } from '..';
import { NumberOnlyDirective } from '@/shared/directives';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
	selector: 'app-quantity-stepper',
	templateUrl: './quantity-stepper.component.html',
	styleUrls: ['./quantity-stepper.component.scss'],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, IconComponent, InputComponent, NumberOnlyDirective],
	providers: [
		QuantityStepperPresenter,
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => QuantityStepperComponent),
			multi: true,
		},
	],
	standalone: true,
})
export class QuantityStepperComponent
	extends IAbstractView<IQuantityStepperPresenter>
	implements IQuantityStepperComponent, ControlValueAccessor
{
	translations = this.presenter.translations;
	formGroup = this.presenter.formGroup;

	@Input() loading$ = this.presenter.loading$;
	@Input() iconIncrement = this.presenter.iconIncrement;
	@Input() iconDecrement = this.presenter.iconDecrement;
	@Input() disabled = this.presenter.disabled;
	@Input() min = this.presenter.min;
	@Input() max = this.presenter.max;

	@Output() changeStepper = this.presenter.changeStepper;

	constructor(presenter: QuantityStepperPresenter) {
		super(presenter);
	}

	// ControlValueAccessor
	_value = this.presenter._value;
	onChange = this.presenter.onChange;
	onTouched = this.presenter.onTouched;

	writeValue(value: number): void {
		this.presenter.writeValue(value);
	}

	registerOnChange(fn: () => void): void {
		this.presenter.registerOnChange(fn);
	}

	registerOnTouched(fn: () => void): void {
		this.presenter.registerOnTouched(fn);
	}

	get value(): number {
		return this.presenter.value;
	}

	set value(v: number) {
		this.presenter.value = v;
	}

	increaseAmount(): void {
		this.presenter.increaseAmount();
	}

	decreaseAmount(): void {
		this.presenter.decreaseAmount();
	}

	changeAmount(): void {
		this.presenter.changeAmount();
	}
}
